"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _constants = require("../constants/constants");
var _utils = require("../utils/utils");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var BwaCheckoutInterstitialLoaderWatcher = /*#__PURE__*/function () {
  function BwaCheckoutInterstitialLoaderWatcher() {
    (0, _classCallCheck2["default"])(this, BwaCheckoutInterstitialLoaderWatcher);
    this.init();
  }
  return (0, _createClass2["default"])(BwaCheckoutInterstitialLoaderWatcher, [{
    key: "init",
    value: function init() {
      try {
        this.initializeObserver();
      } catch (error) {
        console.error("Error initializing BwaCheckoutInterstitialLoaderWatcher:", error);
      }
    }
  }, {
    key: "initializeObserver",
    value: function initializeObserver() {
      var observer = new MutationObserver(function (mutationsList, observer) {
        var _iterator = _createForOfIteratorHelper(mutationsList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mutation = _step.value;
            if (mutation.type === "childList") {
              var element = (0, _utils.safeGetElementById)("bwa-loader-widget-container");
              if (element) {
                window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_CHECKOUT_INTERSTITIAL_LOADER_RENDER));
                observer.disconnect();
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }]);
}();
var _default = exports["default"] = BwaCheckoutInterstitialLoaderWatcher;
//# sourceMappingURL=bwa_checkout_interstitial_loader-watcher.js.map
